import { createSchemaBasedConstructor } from './create-typed-constructor'

const LatLngArray = createSchemaBasedConstructor('LatLngArray')

export default LatLngArray
